import { render, staticRenderFns } from "./ShowSelection.vue?vue&type=template&id=19121baa&scoped=true"
import script from "./ShowSelection.vue?vue&type=script&lang=js"
export * from "./ShowSelection.vue?vue&type=script&lang=js"
import style0 from "./ShowSelection.vue?vue&type=style&index=0&id=19121baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19121baa",
  null
  
)

export default component.exports